/// <reference path="skyward.ui.window.js"/>
/// <reference path="skyward.base.tabbing.js"/>
/// <reference path="skyward.ui.validation.ts"/>
/// <reference path="skyward.ui.distinctmultiselecteel.js"/>
/// <reference path="skyward.ui.controls.js"/>
/// <reference path="skyward.ui.radioButtonGroup.ts"/>
/// <reference path="skyward.ui.browse.js"/>
/// <reference path="skyward.ui.fieldset.js"/>
/// <reference path="skyward.ui.datepicker.js"/>
(
    function (skyward, $, undefined)
    {
        "use strict";

        var toggleRadioButton = function ()
        {
            var context = this;
            context.find(".radioSet, .radioButtonGroup").each(function ()
            {
                var radioset = $(this);
                var inputs = radioset.find("input:radio");
                inputs.change(function ()
                {
                    var input = $(this);
                    doProcessDependents(context, input, true);
                    toggleTab.apply(context);
                });

                var current = radioset.find("input:checked");
                doProcessDependents(context, current, false, true);
                toggleTab.apply(context);
            });
        };

        var toggleDropDown = function ()
        {
            var context = this;
            context.find(".comboBoxSet").each(function (index)
            {
                var comboBoxSet = $(this);
                if (!comboBoxSet.hasClass("DefaultComboBoxSet"))
                {
                    comboBoxSet.change(function (index)
                    {
                        var input = $(this).find('option:selected');
                        doProcessDependents(context, input, true);
                    });

                    var current = comboBoxSet.find("option:selected");
                    doProcessDependents(context, current, false, true);
                }
            });
        };

        var toggleDropDownAlternative = function ()
        {
            var context = this;
            context.find(".clearSpecialDependents").each(function (index)
            {
                var comboBox = $(this);
                comboBox.change(function ()
                {
                    doProcessDependents(context, comboBox, true);
                });

                doProcessDependents(context, comboBox, false, true);
            });
        };

        var toggleEEL = function (context, containerClassname, hiddenValueClassname)
        {
            context.find(containerClassname).each(function (index)
            {
                var eelContainer = $(this);
                var eelHiddenValue = eelContainer.find(hiddenValueClassname);
                eelHiddenValue.change(function ()
                {
                    doProcessDependents(context, eelContainer, true);
                });

                doProcessDependents(context, eelContainer, false, true);
            });
        };

        var toggleCheckBox = function ()
        {
            var context = this;
            context.find("input[type='checkbox']").each(function (index)
            {
                var checkbox = $(this);
                checkbox.off("change", processToggleCheckBox);
                checkbox.on("change", processToggleCheckBox);

                doProcessDependents(context, checkbox, false, true);
            });

            function processToggleCheckBox()
            {
                var checkbox = $(this);
                doProcessDependents(context, checkbox, true);
            }
        };

        var toggleAccountDimensionEEL = function ()
        {
            var context = this;
            context.find(".accountDimensionEEL").each(function ()
            {
                var accountDimensionEEL = $(this);
                var accountDimensionEELValue = accountDimensionEEL.children(".accountDimensionEELValue");
                var accountDimensionEELCode = accountDimensionEEL.children(".accountDimensionEELCode");
                accountDimensionEEL.change(function ()
                {
                    doProcessDependents(context, accountDimensionEEL, true);
                    if (accountDimensionEELCode.hasClass('IsFund') && accountDimensionEELValue.val() !== '')
                    {
                        skyward.tabbing.focusAfter(accountDimensionEELCode);
                    }
                });

                doProcessDependents(context, accountDimensionEEL, false, true);
            });
        };

        var toggleDatepicker = function ()
        {
            var context = this;
            context.find('.datepicker').each(function (index)
            {
                var datepicker = $(this);
                datepicker.change(function (index)
                {
                    doProcessDependents(context, datepicker, true);
                });
                doProcessDependents(context, datepicker, false, true);
            });
        };

        var toggleDistinctMultiSelectEEL = function ()
        {
            var context = this;
            context.find('.distinctMultiSelectEEL').each(function ()
            {
                var distinctMultiSelectEEL = $(this);
                distinctMultiSelectEEL.change(function ()
                {
                    doProcessDependents(context, distinctMultiSelectEEL, true);
                });
                doProcessDependents(context, distinctMultiSelectEEL, false, true);
            });
        };

        var toggleTextBox = function ()
        {
            var context = this;
            context.find("input[type='text']").each(function ()
            {
                var textbox = $(this);
                textbox.change(function ()
                {
                    doProcessDependents(context, textbox, true);
                });
                doProcessDependents(context, textbox, false, true);
            });
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(toggleRadioButton);
        skyward.window.registerLoadDOMCallback(toggleDropDown);
        skyward.window.registerLoadDOMCallback(toggleDropDownAlternative);
        skyward.window.registerLoadDOMCallback(function ()
        {
            toggleEEL(this, ".codeEEL", ".codeEELValue");
            toggleEEL(this, ".tileViewEEL", ".tileViewEEL_value");
        });
        skyward.window.registerLoadDOMCallback(toggleCheckBox);
        skyward.window.registerLoadDOMCallback(toggleAccountDimensionEEL);
        skyward.window.registerLoadDOMCallback(toggleDatepicker);
        skyward.window.registerLoadDOMCallback(toggleDistinctMultiSelectEEL);
        skyward.window.registerLoadDOMCallback(toggleTextBox);

        // Main function to fire off when changing the value of a parent
        var doProcessDependents = function (context, input, parentChanged, isLoading)
        {
            if (input.hasClass('editableFields'))
            {
                return;
            }

            var fauxFormLoad = $('#FauxFormLoad');
            if (fauxFormLoad.length > 0)
            {
                isLoading = fauxFormLoad.val() === "true";
            }

            var dependents = input.data("dependents");

            if (dependents === undefined && input.is("option"))
            {
                dependents = input.parent().data("dependents");
            }

            if (dependents)
            {
                var triggerDependency = dependents.triggerOnLoad || (parentChanged && !isLoading);
                if (triggerDependency)
                {
                    $.each(dependents.dependents, function (index)
                    {
                        var panel = skyward.window.getClosestContentPanel(context);
                        if (panel.length == 0)
                        {
                            panel = context;
                        }

                        var currentDependent = panel.find('[id="' + this.Id + '"]');
                        if (currentDependent.length === 0)
                        {
                            // TODO: (5270635) check if this is needed
                            currentDependent = panel.find(`[data-prefixed-id="${this.Id}"]`);
                        }

                        var dependencies = this;

                        var doProcessDependentLogic = function (dependent, dependentRef)
                        {
                            if (dependent.hasClass('editableFields'))
                            {
                                return;
                            }

                            //process single dependent
                            var attemptedValueChangeBreak = true;

                            if (!(!isLoading || dependentRef.TriggerOnLoad === 'true') || !(parentChanged || dependencies.TriggerOnLoad === 'true'))
                            {
                                return;
                            }

                            var value = skyward.controls.getValue(input);
                            value = (value !== undefined && value !== null) ? value.toString() : "";

                            var onValueArray = (typeof dependencies.OnValue === "string") ? dependencies.OnValue.split(',') : [];
                            var notOnValueArray = (typeof dependencies.NotOnValue === "string") ? dependencies.NotOnValue.split(',') : [];

                            if (dependencies.OnValue !== undefined && !onValueArray.includes(value))
                            {
                                return;
                            }
                            if (dependencies.NotOnValue !== undefined && notOnValueArray.includes(value))
                            {
                                return;
                            }

                            //If we are clearing the dependencies, we don't care what the input is
                            if (dependencies.Clear && dependencies.Clear === "true")
                            {
                                if (input.hasClass('setByWorkflowTemplate'))
                                {
                                    input.removeClass('setByWorkflowTemplate');
                                }
                                else
                                {
                                    clearDependent(dependent);
                                }
                            }

                            //If the dependent is a checkbox, and we are toggling or clearing, we don't care what the input is
                            if (dependent.is(":checkbox"))
                            {
                                if (dependencies.Toggle === "true")
                                {
                                    setCheckboxValue(dependent, !dependent.prop("checked"));
                                    attemptedValueChangeBreak = false;
                                }
                                if (dependencies.Clear === "false")
                                {
                                    setCheckboxValue(dependent, true);
                                    attemptedValueChangeBreak = false;
                                }
                            }

                            //Process the remaining options that require us to know what the value is on the input
                            if ((input.is(":checkbox, input:radio") && input.prop("checked")) || //Checkbox & Radio Button
                                input.is("option") || //Combobox Option
                                (input.is("div.codeEEL") && input.find(".codeEELValue").val()) || //CodeEEL
                                (input.is("div.accountDimensionEEL") && input.find(".accountDimensionEELValue").val()) ||//AccountDimensionEEL
                                (input.is(".distinctMultiSelectEEL") && skyward.distinctmultiselecteel.getSearchParameters(input.find('.dmsBackingData')).length > 0) ||
                                (input.is("input") && input.is(".datepicker,.text,.number,.timePickerBox,.durationpicker") && input.val() !== "") ||
                                (input.hasClass("tileViewEEL") && input.find(".tileViewEEL_value").val()))
                            {
                                if (dependencies.Visibility)
                                {
                                    setVisibility(dependent, dependencies.Visibility === "true", dependencies.AnimateVisibilityChange !== "false");
                                }

                                if (dependencies.ReadOnly)
                                {
                                    setReadOnly(dependent, dependencies.ReadOnly === "true");
                                    if (dependent.is(":text"))
                                    {
                                        setTextboxMask(dependent, input.is(":checked"));
                                    }
                                }

                                if (dependent.is(":checkbox") && triggerDependency && dependencies.Value)
                                {
                                    setCheckboxValue(dependent, typeof(dependencies.Value) === "string" && dependencies.Value.toLowerCase() === "true");
                                    attemptedValueChangeBreak = false;
                                }

                                if (dependent.is(":text") && triggerDependency && dependencies.Mask && dependencies.showMask)
                                {
                                    setTextboxMask(dependent, dependencies.showMask == input.is(":checked"));
                                }

                                if (triggerDependency && dependencies.ClearErrors)
                                {
                                    skyward.validation.displayValidationMessages(null, dependencies.ClearErrors, null, null);
                                }

                                if (dependent.is(":radio") && triggerDependency && dependencies.Value)
                                {
                                    setRadioButtonValue(dependent, dependencies.Value === "true");
                                    attemptedValueChangeBreak = false;
                                }
                            }
                            else
                            {
                                if (dependencies.Visibility)
                                {
                                    setVisibility(dependent, dependencies.Visibility !== "true");
                                }

                                if (dependencies.ReadOnly)
                                {
                                    setReadOnly(dependent, dependencies.ReadOnly !== "true");
                                    if (dependent.is(":text"))
                                    {
                                        setTextboxMask(dependent, input.is(":checked") || dependencies.showMask);
                                    }
                                }

                                if (dependent.is(":checkbox") && triggerDependency && dependencies.Value)
                                {
                                    setCheckboxValue(dependent, dependencies.Value !== "true");
                                    attemptedValueChangeBreak = false;
                                }

                                if (dependent.is(":text") && triggerDependency && dependencies.Mask && dependencies.showMask)
                                {
                                    setTextboxMask(dependent, dependencies.showMask == input.is(":checked"));
                                }
                            }

                            if (triggerDependency && dependencies.Value && (dependent.is(":text") || dependent.hasClass("radioSet") || dependent.hasClass("comboBoxSet") || dependent.hasClass("codeEEL"))) // TODO This is flawed logic. A radio button with the value of "false" cannot be be set by this code. Also, it fails to honor OnValue.
                            {
                                skyward.controls.setValue(dependent, dependencies.Value);
                                attemptedValueChangeBreak = false;
                            }
                            else if (triggerDependency && dependent.hasClass("radioButtonGroup") && dependencies.Value !== undefined &&
                                (dependencies.OnValue === undefined || onValueArray.includes(value)))
                            {
                                skyward.radioButtonGroup.setValue(dependent.find(".radioButtonGroupValue"), dependencies.Value);
                                attemptedValueChangeBreak = false;
                            }

                            if (dependencies.CopyParentValue)
                            {
                                setDependentValue(dependent, skyward.controls.getValue(input));
                            }
                            else if (dependencies.DependentValue)
                            {
                                setDependentValue(dependent, dependencies.DependentValue);
                            }

                            if (dependent.is(":input"))
                            {
                                if (dependencies.Placeholder)
                                {
                                    dependent.attr('placeholder', dependencies.Placeholder);
                                }
                            }

                            // Currently, Editable Browse dependency works differently than regular browses
                            if (dependent.is(".browse:not(.editablebrowse)"))
                            {
                                var filterPostData = {};
                                $.each(dependent.data("dependency")?.dependencyItems, function ()
                                {
                                    var control = $("#" + this.ControlID);
                                    filterPostData[this.PostKey] = skyward.controls.getValue(control);
                                });

                                skyward.browse.updateDependency(dependent.attr("id"), { dependencyPostData: filterPostData });
                            }

                            // Dependent Value takes precedence over a Value Function
                            if (!dependencies.DependentValue && dependencies.ValueFunction)
                            {
                                if (dependencies.ValueFunctionArgs === undefined)
                                {
                                    dependencies.ValueFunctionArgs = '';
                                }

                                applyValueFunction(dependent, dependencies.ValueFunction, dependencies.ValueFunctionArgs);
                            }

                            if (skyward.controls.valueHasChanged(dependent))
                            {
                                if (!attemptedValueChangeBreak)
                                {
                                    doProcessDependents(context, dependent, true, isLoading);
                                }
                            }
                        };

                        //TODO @ME This is not valid logic
                        // this determines if the current dependent is a normal dependent or part of the Incident Quick Entry repeater
                        if (currentDependent.length !== 0)
                        {
                            doProcessDependentLogic(currentDependent, this);
                        }
                        else
                        {
                            var quickEntryDependents = $('.disciplineQuickEntryColumn [id^="' + this.Id + '-add-"]');
                            if (quickEntryDependents.length === 1)
                            {
                                doProcessDependentLogic(quickEntryDependents, this);
                            }
                            else if (quickEntryDependents.length > 1)
                            {
                                quickEntryDependents.each(function ()
                                {
                                    doProcessDependentLogic($(this), this);
                                });
                            }
                            else
                            {
                                //console.log(`Could not find dependent with ID ${this.Id} for element`, input);
                            }
                        }
                    });
                }
                skyward.window.notifyResize();
            }
            else if (input.hasClass("setByWorkflowTemplate"))
            {
                input.removeClass("setByWorkflowTemplate");
            }
        };

        // Function to select the visible tab.
        // When switching ui components tabs maybe hidden, so we need to ensure the first visibile tab is selected.
        var toggleTab = function ()
        {
            this.find(".tabContainer").each(function (index)
            {
                var container = $(this);
                var tabButtonList = container.find(".tabStrip .tabButton");
                var tabContentsList = container.find(".tabContents");

                tabButtonList.each(function (index)
                {
                    var button = $(this);
                    var contents = $(tabContentsList[index]);

                    if (button.is(":visible"))
                    {
                        tabButtonList.removeClass("current");
                        button.addClass("current");
                        tabContentsList.removeClass("current");
                        contents.addClass("current");
                        return false;
                    }
                });
            });
        };

        // Function to clear a dependent control
        var clearDependent = function (dependent)
        {
            if (dependent.hasClass('setByWorkflowTemplate'))
            {
                dependent.removeClass('setByWorkflowTemplate');
                return;
            }

            if (dependent.hasClass('editableFields'))
            {
                return;
            }

            if (dependent.hasClass("DefaultComboBoxSet"))
            {
                return;
            }

            if (dependent.hasClass("standardFilterViewer"))
            {
                skyward.standardfilterviewer.clear(dependent);
            }
            else if (dependent.is(":checkbox"))
            {
                setCheckboxValue(dependent, false);
            }
            else if (dependent.hasClass("checkboxGroup"))
            {
                skyward.checkboxgroup.toggleAll(dependent, false);
            }
            else if (dependent.is(".radioButtonGroupValue"))
            {
                dependent.closest(".radioButtonGroup").find("[type='radio']").prop("checked", false);
                skyward.controls.setValue(dependent, null);
            }
            else if (dependent.is(":radio"))
            {
                dependent.prop("checked", false);
            }
            else if (dependent.is("div.codeEEL"))
            {
                clearDependentParts(dependent, ".codeEELValue, .codeEELCode, .codeEELDescription, .codeEELSelectedValueDisplayField");
            }
            else if (dependent.hasClass(".tileViewEEL"))
            {
                clearDependentParts(dependent, ".tileViewEEL_value, .tileViewEEL_search");
            }
            else if (dependent.is(".distinctMultiSelectEEL"))
            {
                dependent.children(".selectedItems").find(".selectedItem:not(.dummyTile)").remove();
                skyward.controls.clearValue(dependent);
            }
            else if (dependent.hasClass("multipleSelectBox"))
            {
                dependent.children().each(function ()
                {
                    var element = $(this);
                    if (element.hasClass("multiSelectBackingData"))
                    {
                        element.data("searchParameters").length = 0;
                        element.change();
                    }
                    else if (element.hasClass("multipleSelectOption"))
                    {
                        var checkbox = element.find(".multipleSelectOptionCheckbox");
                        checkbox.prop("checked", false);
                    }
                });
            }
            else if (dependent.hasClass("filterContainer"))
            {
                var filterBuilderLaunchButton = dependent.find(".filterBuilderLaunchButton");
                skyward.filterbuilder.updateFilter(filterBuilderLaunchButton, null);
            }
            else if (dependent.is("div") || dependent.is("fieldset"))
            {
                if (dependent.hasClass("setByWorkflowTemplate"))
                {
                    dependent.removeClass("setByWorkflowTemplate");
                }
                else
                {
                    //The dependent is a container, so clear all of the child controls
                    dependent.children().each(function ()
                    {
                        clearDependent($(this));
                    });
                }
            }
            else if (dependent.is("input") || dependent.is("textarea") || dependent.is("select"))
            {
                skyward.controls.setValue(dependent, null);
            }
            else
            {
                dependent.val(null);
            }
        };

        var clearDependentParts = function (dependent, childrenSelectors)
        {
            dependent.find(childrenSelectors).each(function ()
            {
                skyward.controls.setValue($(this), "");
            });
        };

        // Function to change the visibility of an input
        var setVisibility = function (input, value, animate)
        {
            if (input && !input.hasClass("tabContents"))
            {
                skyward.controls.toggleVisible(input, value, animate);
            }
        };

        // Function to change the readonly/disabled state of an input
        var setReadOnly = function (element, isReadOnly)
        {
            if (!skyward.controls.toggle(element, !isReadOnly) && element.is("div,fieldset"))
            {
                //Update all of the child controls
                element.children().each(function ()
                {
                    setReadOnly($(this), isReadOnly);
                });
            }
        };

        // Function to set a checkbox value
        var setCheckboxValue = function (checkbox, value)
        {
            if (checkbox.is(":checkbox"))
            {
                checkbox.prop("checked", value);
                checkbox.change();
            }
        };

        var setRadioButtonValue = function (radioButton, value)
        {
            if (radioButton.is(":radio"))
            {
                radioButton.prop("checked", value);
                radioButton.change();
            }
        };

        var setTextboxMask = function (textbox, showMask)
        {
            const textboxData = textbox.data();
            if (showMask)
            {
                if (textboxData.decimalMask != null)
                {
                    skyward.datamask.addDecimalMask(textbox, textbox.data().decimalMask.toString(), null);
                }
                else if (textboxData.mask != null)
                {
                    skyward.datamask.addMask(textbox, textbox.data().mask, null);
                }

            }
            else
            {
                if (textboxData.mask || textboxData.decimalMask)
                {
                    skyward.datamask.removeMask(textbox);
                }
            }
        };

        var setDependentChildrenValues = function (dependent, childSelector, value)
        {
            dependent.children(childSelector).each(function ()
            {
                $(this).val(value);
            });
        };

        // Function to set dependent value
        var setDependentValue = function (dependent, value)
        {
            if (dependent.hasClass("DefaultComboBoxSet"))
            {
                return;
            }

            if (dependent.is(":checkbox"))
            {
                setCheckboxValue(dependent, value);
            }
            else if (dependent.is("div.codeEEL"))
            {
                setDependentChildrenValues(dependent, ".codeEELValue, .codeEELCode, .codeEELDescription", value);
            }
            else if (dependent.hasClass("tileViewEEL"))
            {
                setDependentChildrenValues(dependent, ".tileViewEEL_value, .tileViewEEL_search", value);
            }
            else if (dependent.is("label"))
            {
                dependent.text(value);
                skyward.fieldset.alignTitles("#" + dependent.attr('id'));
            }
            else
            {
                var maxLength = dependent.attr('maxlength');
                if (maxLength !== undefined && typeof value === "string" && value.length > maxLength)
                {
                    value = value.substring(0, maxLength);
                }

                skyward.controls.setValue(dependent, value);

                if (dependent.is("select") || dependent.is("input"))
                {
                    dependent.change();
                }

                if (dependent.hasClass('datepicker'))
                {
                    skyward.datepicker.setDatePicker(dependent);
                }
            }
        };

        const applyValueFunction = function (dependent, valueFunction, valueFunctionArgs)
        {
            const updateEvent = "keyup";
            let functionToUse = skyward.events.getActionFunction(valueFunction);

            if (functionToUse === undefined)
            {
                const functionParts = valueFunction.split(".");

                functionToUse = window[functionParts[0]];

                for (var part = 1; part < functionParts.length; part++)
                {
                    functionToUse = functionToUse[functionParts[part]];
                }
            }

            const argArray = valueFunctionArgs.split(",");
            const elements = [];

            for (let i = 0; i < argArray.length; i++)
            {
                if (argArray[i].charAt(0) === "#")
                {
                    elements.push($(argArray[i]));
                }
            }

            if (elements.length > 0)
            {
                for (let j = 0; j < elements.length; j++)
                {
                    const jqThis = elements[j];
                    const attributeName = 'data-example-codependent-' + dependent.attr('id') + '-' + valueFunction + '-' + valueFunctionArgs.split('#').join('').split(',').join('-') + '-bound';
                    if (jqThis.attr(attributeName) === undefined)
                    {
                        elements[j].debounce(updateEvent, function ()
                        {
                            const newArgsArray = [];

                            for (let k = 0; k < argArray.length; k++)
                            {
                                if (argArray[k].charAt(0) === '#')
                                {
                                    const element = $(argArray[k]);
                                    newArgsArray.push(element.val());
                                }
                                else
                                {
                                    newArgsArray.push(argArray[k]);
                                }
                            }

                            setDependentValue(dependent, functionToUse.apply(null, newArgsArray));
                        });

                        jqThis.attr(attributeName, 'true');
                    }
                }
            }
            else
            {
                setDependentValue(dependent, functionToUse.apply(null, arguments));
            }

            // Trigger event to update
            if (elements[0])
            {
                elements[0].trigger(updateEvent);
            }
        };

    }(window.skyward = window.skyward || {}, window.jQuery)
);